import { render, staticRenderFns } from "./DetailsView.vue?vue&type=template&id=99b0559e&scoped=true&"
import script from "./DetailsView.vue?vue&type=script&lang=js&"
export * from "./DetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DetailsView.vue?vue&type=style&index=0&id=99b0559e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b0559e",
  null
  
)

export default component.exports